<template>
  <div class="profile-experience">
    <div v-if="!$root.isDesktop" class="profile-experience__name-avatar">
      <div class="profile-experience__name">
        <div class="name__greeting">Привет,</div>
        <div class="name__firstname" v-html="firstName || ''" :title="firstName || ''"></div>
      </div>
      <div class="profile-experience__avatar">
        <div class="avatar" :class="{ 'avatar_pointer': hideEdit }" @click.stop="onSettings">
          <div class="avatar__image" :style="{ 'background-image': `url(${avatar})` }" @click.stop="onSettings"></div>
          <div v-if="!hideEdit" class="avatar__edit" @click.stop="onEditAvatar">
            <Icon name="edit" size="m" />
          </div>
        </div>
      </div>
    </div>
    <div class="profile-experience__items" :class="{ 'no-steps' : !isSpecialSettingsMp}">
      <div class="profile-experience__xp-achievements">
        <div class="xp-achievements__xp">
          <div class="xp__content">
            <div class="xp__labels">
              <div class="xp__level">{{ currentLevel }} ур.</div>
              <div class="xp__values"><span>{{ currentValue - currentLevelStartValue }}</span><span> / {{ nextLevelValue - currentLevelStartValue }} XP</span></div>
            </div>
            <div class="xp__bar">
              <div :style="{ 'width': `${ getPercent() }%` }"></div>
            </div>
          </div>
          <div class="xp__question">
            <Button
              id="showLevelInfo"
              variant="secondary"
              shape="circle"
              size="sm"
              iconLeft="question"
            ></Button>
            <Dropdown
              triggerId="showLevelInfo"
              :placement="$root.isDesktop ? 'top-end' : 'top'"
              listeners="click"
              hide-overlay
              auto-width
            >
              <template slot="items">
                <LevelInfo
                  :level="currentLevel"
                  :needXP="needXP"
                />
              </template>
            </Dropdown>
          </div>
        </div>
        <div class="xp-achievements__achievements">
          <div
            v-for="item in activeAchievements"
            :key="item.achievementId"
            class="achievements__item"
            @click.stop="onSelected(item.achievementKey)"
          >
            <img :src="item.achievementIconUrl" :alt="getAchievementName(item.achievementKey)" />
          </div>
          <div
            v-if="countMore > 0"
            class="achievements__item"
            @click.stop="onSelected('Welcome')"
          >
            <img :src="imageMore" />
            <div class="item__more">+{{ countMore }}</div>
          </div>
        </div>
      </div>
      <div class="profile-experience__item step-item" @click="onShowStepsModal" v-if="isSpecialSettingsMp">
        <div class="step-item__block">
          <p class="step-item__title">Шагов сегодня</p>
          <span class="step-item__value">{{ stepsPosition }}</span>
        </div>
        <div class="">
          <IndexSteps
            :value="stepsPosition"
            :targetSteps="steps ? steps.target : 0"
            @show="onShowIndexOFP"
          />
        </div>
        <div class="step-item__block">
          <p class="step-item__title">Вы получили</p>
          <div class="step-item__value">
            <img :src="coinImg"/>
            <span>{{ accruedPoints }}</span>
          </div>
        </div>
      </div>
      <div @click="onShowIndexOFP" class="profile-experience__item">
        <IndexOFP
          v-if="sportIndexes"
          :value="sportIndexes.index"
          :dates="formatDateRange({ start: sportIndexes.startDate, finish: sportIndexes.finishDate })"
          @show="onShowIndexOFP"
        />
      </div>
    </div>
    <Modal
      :active="achievementsModal"
      name="AchievementsModal"
      title="Мои достижения"
      :subtitle="`Получено ${ $props.achievements ? $props.achievements.filter(item => item.unlocked).length : 0 } / ${ $props.achievements ? $props.achievements.length : 0 }`"
      :class="{ 'for-mobile-app': isMobileApp }"
      @close="achievementsModal = false"
    >
      <div class="modal-content text-left">
        <div
          v-for="cat in categories"
          :key="cat.id"
          class="modal-content__group"
          :class="{ 'd-none': getCountOfCat(cat.id) === 0 }"
        >
          <div class="modal-content__group-title" @click.stop="!$root.isDesktop ? setCollapsed(cat.id) : null">
            <div class="group-title__name">
              <div class="group-title__text" v-html="cat.name || ''"></div>
              <div class="group-title__count">Получено {{ getActiveOfCatCount(cat.id) }} / {{ getCountOfCat(cat.id) }}</div>
            </div>
            <div class="group-title__icon" @click.stop="setCollapsed(cat.id)">
              <Icon v-if="cat.collapsed" name="down" size="xl" />
              <Icon v-else name="up" size="xl" />
            </div>
          </div>
          <div v-if="!cat.collapsed" class="modal-content__group-details">
            <div
              v-for="item in getAchievementsOfCat(cat.id)"
              :key="item.achievementId"
              class="group-details__achievement text-center"
            >
              <div
                class="group-details__image"
                @click.stop="onAchievementDetails(item)"
              >
                <img :src="item.achievementIconUrl" :alt="item.achievementKey || ''" />
              </div>
              <div class="group-details__title" v-html="item.achievementTitle || ''" @click.stop="onAchievementDetails(item)"></div>
            </div>
          </div>
        </div>
      </div>
    </Modal>

    <Modal
      :active="descriptionModal"
      name="AchievementDescriptionModal"
      class="achievement__description"
      :class="{ 'for-mobile-app': isMobileApp }"
      @close="descriptionModal = false"
    >
      <div class="achievement__description-img">
        <img :src="descriptionImageClass" :alt="descriptionTitle" />
      </div>
      <div class="achievement__description-title" v-html="descriptionTitle"></div>
      <div class="achievement__description-subtitle" v-html="descriptionSubtitle"></div>
      <Button
        text="Назад к достижениям"
        variant="secondary"
        size="lg"
        wide
        mobile
        @click="descriptionModal = false"
      ></Button>
    </Modal>

    <Modal
      :active="indexOFPModal"
      :img="ofpImage"
      :title="ofpTitle"
      :subtitle="ofpSubtitle"
      name="IndexOFPModal"
      class="index-ofp"
      :class="{ 'for-mobile-app': isMobileApp }"
      @close="indexOFPModal = false"
    >
      <div class="ofp">
        <div class="ofp__value">
          <Slider
            v-if="indexOFPModal && ofpValues.length > 0"
            :initialSlide="initialSlide"
            :navigationOffset="navigationOffset"
            :noPagination="noPagination"
            class="ofp__slider"
          >
            <IndexOFP
              v-for="(item, i) in ofpValues"
              :key="i"
              :value="ofpValues[i].value"
              :dates="ofpValues[i].dates"
              :simple="true"
            />
          </Slider>
        </div>
        <div class="ofp__description" v-html="ofpDescription"></div>
        <Button
          class="ofp-more"
          text="Узнать больше"
          variant="secondary"
          tag="a"
          :target="!isMobileApp ? '_blank' : ''"
          :href="articleAboutIndexOFP"
          size="lg"
          mobile
        ></Button>
      </div>
    </Modal>

    <Modal
      :active="guideModal"
      name="guideModal"
      :class="{ 'for-mobile-app': isMobileApp }"
      @close="guideModal = false"
    >
    <div class="guide__title guide__title_steps" v-html="guideTitle"></div>
    <div v-if="$root.isMobile" class="guide__subtitle guide__subtitle_steps">
      <b>Шаг 1.</b> Скопируйте код для входа в спортивную программу
      <div class="guide__passcode guide__passcode_color">
        <span>{{ code ? code.code : '' }}</span>
        <span @click.stop="onCopyCode"><Icon name="copy" /></span>
      </div>
    </div>
    <div v-if="!$root.isMobile" class="guide__subtitle guide__subtitle_steps">
      <b>Шаг 1.</b> Установите приложение
      <div class="guide__platform-link">
      <a v-if="OS === 'unknown'" href="https://apps.apple.com/ru/app/%D1%81%D0%BA%D0%B0%D1%83%D0%BD%D1%82/id6504521298" target="_blank"><img :src="appStoreImg"/></a>
      <a v-if="OS === 'unknown'" target="_blank"  href="https://play.google.com/store/apps/details?id=pro.scount.app&pli=1" class="modal-qrcode__item">
        <img class="modal-qrcode__item-img" :src="googleplayImg" alt="" />
      </a>
      <a v-if="OS === 'unknown'" href="https://www.rustore.ru/catalog/app/pro.scount.app" target="_blank"><img :src="rustoreImg"/></a>
    </div>
    <div class="guide__platform-link">
      <a v-if="OS === 'iOS'" href="https://apps.apple.com/ru/app/%D1%81%D0%BA%D0%B0%D1%83%D0%BD%D1%82/id6504521298" target="_blank"><img :src="appStoreImg"/></a>
      <a v-if="OS === 'Android'" href="https://www.rustore.ru/catalog/app/pro.scount.app" target="_blank"><img :src="rustoreImg"/></a>
    </div>
    </div>
    <div v-if="$root.isMobile" class="guide__subtitle guide__subtitle_steps">
      <b>Шаг 2.</b> Установите приложение и войдите с помощью кода из шага 1
      <div class="guide__platform-link">
      <a v-if="OS === 'unknown'" href="https://apps.apple.com/ru/app/%D1%81%D0%BA%D0%B0%D1%83%D0%BD%D1%82/id6504521298" target="_blank"><img :src="appStoreImg"/></a>
      <a v-if="OS === 'unknown'" target="_blank"  href="https://play.google.com/store/apps/details?id=pro.scount.app&pli=1" class="modal-qrcode__item">
        <img class="modal-qrcode__item-img" :src="googleplayImg" alt="" />
      </a>
      <a v-if="OS === 'unknown'" href="https://www.rustore.ru/catalog/app/pro.scount.app" target="_blank"><img :src="rustoreImg"/></a>
    </div>
    <div class="guide__platform-link">
      <a v-if="OS === 'iOS'" href="https://apps.apple.com/ru/app/%D1%81%D0%BA%D0%B0%D1%83%D0%BD%D1%82/id6504521298" target="_blank"><img :src="appStoreImg"/></a>
      <a v-if="OS === 'Android'" href="https://www.rustore.ru/catalog/app/pro.scount.app" target="_blank"><img :src="rustoreImg"/></a>
      <a v-if="OS === 'Android'" target="_blank"  href="https://play.google.com/store/apps/details?id=pro.scount.app&pli=1" class="modal-qrcode__item">
        <img class="modal-qrcode__item-img" :src="googleplayImg" alt="" />
      </a>
    </div>
    </div>
    <!-- <div v-if="android || iOS" class="guide__platform-link">
      <a :href="android ? appAndroid : appiOS" target="_blank"><img :src="android ? googlePlayImg : appStoreImg"/></a>
    </div> -->
    <div v-if="!$root.isMobile" class="guide__subtitle guide__subtitle_steps">
      <b>Шаг 2.</b> Введите код спортивной программы в приложении
      <div class="guide__passcode guide__passcode_color">
        <span>{{ code ? code.code : '' }}</span>
        <span @click.stop="onCopyCode"><Icon name="copy" /></span>
      </div>
    </div>
    <div class="guide__subtitle guide__subtitle_steps">
      <b>Шаг 3.</b> Разрешите приложению доступ к данным физической активности
      <div>
        <span v-if="OS === 'unknown'"><img :src="healthConnectImg"/></span>
        <span v-if="OS === 'unknown'"><img :src="healthImg"/></span>
        <span v-if="OS === 'Android'"><img :src="healthConnectImg"/></span>
        <span v-if="OS === 'iOS'"><img :src="healthImg"/></span>
      </div>
    </div>
    <div class="guide__footer">
      Ходите и получайте <br> <b>по 2 <img :src="coinImg"/> за каждую 1 000 шагов</b>
    </div>
    <div class="sneak-bar" v-if="showCopied">
      <Alert
        text="Код скопирован."
        actionText="Понятно"
        state="success"
        closable
        autoClose
        @close="showCopied = false"
      ></Alert>
    </div>
    </Modal>

    <SetAvatarModal
      :active="showSetAvatar"
      :isMobileApp="isMobileApp"
      class="set-avatar"
      @close="showSetAvatar = false"
    ></SetAvatarModal>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Alert from '@rr-component-library/alert/src/main';
import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import SetAvatarModal from '@/components/SetAvatarModal/SetAvatarModal.vue';
import Dropdown from '@/components/Dropdown/Dropdown.vue';
import LevelInfo from '@/components/LevelInfo/LevelInfo.vue';
import IndexOFP from '@/components/IndexOFP/IndexOFP.vue';
import IndexSteps from '@/components/IndexOFP/IndexSteps.vue';
import AchievementsAll from '@/assets/data/achievements';
import WHOImage from '@/assets/img/index-ofp/who.svg';
import GooglePlayImg from '@/assets/img/connection-guide/google-play.svg';
import AppStoreImg from '@/assets/img/connection-guide/app-store.svg';
import RuStoreImg from '@/assets/img/connection-guide/rustore.svg';
import HealthImg from '@/assets/img/connection-guide/health.svg';
import HealthConnectImg from '@/assets/img/connection-guide/health-connect-app.svg';
import CoinImg from '@/assets/img/coin.svg';
import ScountImgMiddle from '@/assets/img/scount-middle.svg';
import { formatDateRange, addNonBreakingSpaces, getArticleByKey } from '@/assets/js/helpers';

dayjs.extend(weekday);

const DIR = '/img/achievements';

export default {
  name: 'ProfileExperience',
  props: {
    firstName: String,
    avatar: String,
    experience: Object,
    achievements: Array,
    sportIndexes: Object,
    hideEdit: Boolean,
    isMobileApp: Boolean,
    steps: Object,
  },
  components: {
    SetAvatarModal,
    Dropdown,
    LevelInfo,
    IndexOFP,
    IndexSteps,
    Alert,
  },
  data() {
    return {
      achievementsAll: AchievementsAll,
      categories: [
        { id: 'General', name: 'Общие', collapsed: false },
        { id: 'Team', name: 'Командные', collapsed: true },
        { id: 'Walking', name: 'Ходьба', collapsed: true },
        { id: 'Running', name: 'Бег', collapsed: true },
        { id: 'Cycling', name: 'Велозаезд', collapsed: true },
        { id: 'Swimming', name: 'Плавание', collapsed: true },
        { id: 'Skiing', name: 'Лыжи', collapsed: true },
        { id: 'Market', name: 'Маркет', collapsed: true },
      ],
      imageMore: `${DIR}/system-empty.svg`,
      countMore: 0,
      activeAchievements: [],
      grayAchievements: [],
      maxMobileItems: 7,
      maxDesktopItems: 6,
      achievementsModal: false,
      descriptionModal: false,
      descriptionImageClass: '',
      descriptionTitle: '',
      descriptionSubtitle: '',
      showSetAvatar: false,
      showStepDynamic: false,
      indexOFPModal: false,
      stepsModal: false,
      ofpImage: WHOImage,
      googleplayImg: GooglePlayImg,
      appStoreImg: AppStoreImg,
      rustoreImg: RuStoreImg,
      healthImg: HealthImg,
      healthConnectImg: HealthConnectImg,
      scountImg: ScountImgMiddle,
      coinImg: CoinImg,
      ofpTitle: 'ОФП-индекс на основе<br/>рекомендаций ВОЗ',
      ofpSubtitle: 'Еженедельно достигая <b>150 ОФП</b>, вы можете продлить себе жизнь, улучшить качество сна и поднять настроение.',
      ofpDescription: 'Индекс ОФП повышается за каждую минуту активных физических нагрузок, например бега.',
      stepsDescription: 'Шаги обновляются при каждом входе в приложение SCOUNT',
      ofpValues: [],
      guideModal: false,
      showCopied: false,
      targetSteps: 120,
      accruedPoints: 0,
      stepsPosition: 0,
    };
  },
  computed: {
    ...mapGetters('settings', ['theme', 'options', 'resources']),
    ...mapGetters('user', ['code', 'profile', 'hasParticipantActiveDeviceSession']),
    ...mapGetters('steps', ['stepsHistory', 'participantPositionData']),
    ...mapGetters('content', ['articles']),
    currentLevel() {
      return this.experience ? this.experience.level : 1;
    },
    currentValue() {
      return this.experience ? this.experience.value : 0;
    },
    nextLevelValue() {
      return this.experience ? this.experience.nextLevelValue : 0;
    },
    currentLevelStartValue() {
      return this.experience ? this.experience.currentLevelStartValue : 0;
    },
    needXP() {
      return this.nextLevelValue - this.currentValue;
    },
    showIndexOFP() {
      return this.options ? this.options.showIndexOFP === true : false;
    },
    showAchievementTypes() {
      return this.options ? this.options.showAchievementTypes || [] : [];
    },
    articleAboutIndexOFP() {
      const link = getArticleByKey(this.articles, 'key_10');
      return link || '#';
    },
    navigationOffset() {
      return {
        default: '0', md: '72', lg: '72', xl: '83',
      };
    },
    noPagination() {
      return true;
    },
    navigationOffset1() {
      return {
        default: '0', md: '72', lg: '72', xl: '83',
      };
    },
    noPagination1() {
      return true;
    },
    initialSlide() {
      return this.ofpValues.length > 0 ? this.ofpValues.length - 1 : 0;
    },
    initialStepsSlide() {
      return this.stepsHistory.length > 0 ? this.stepsHistory.length - 1 : 0;
    },
    walkingAroundRafiki() {
      return this.resources ? this.resources.walkingAroundRafiki || '' : '';
    },
    isSpecialSettingsMp() {
      return this.options ? this.options.isSpecialSettingsMp === true : false;
    },
    guideTitle() {
      return addNonBreakingSpaces('Подключите учёт шагов в приложении БегунДа');
    },
    OS() {
      const userAgent = navigator.userAgent || navigator.vendor || (window).opera;
      if (/android/i.test(userAgent)) {
        return 'Android';
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'iOS';
      }
      return 'unknown';
    },
  },
  methods: {
    ...mapActions('user', ['getCode']),
    ...mapActions('steps', ['getParticipantPositionData']),

    currentPosition() {
      const date = dayjs().format('YYYY-MM-DD');
      this.getParticipantPositionData({ dateFrom: date, periodType: 'daily' })
        .then(() => {
          this.accruedPoints = this.participantPositionData.accruedPoints || 0;
          this.stepsPosition = this.participantPositionData.steps || 0;
        });
    },
    onShowStepsModal() {
      if (!this.hasParticipantActiveDeviceSession) {
        this.guideModal = true;
      } else {
        this.$emit('show-modal');
      }
    },
    getCodeMp() {
      if (this.profile) {
        this.getCode(this.profile.marketingProgramId)
          .then(() => {
            if (this.responseStatus === 200) {
              this.loading = false;
            }
          });
      }
    },
    onCopyCode() {
      navigator.clipboard.writeText(this.code.code);
      if (this.showCopied) this.showCopied = false;
      setTimeout(() => { this.showCopied = true; }, 500);
    },
    onSelected(achievementType) {
      if (achievementType) {
        this.achievementsModal = true;
      }
    },
    onAchievementDetails(item) {
      if (item) {
        this.descriptionImageClass = this.getAchievementIconUrl(item.achievementKey);
        this.descriptionTitle = item.achievementTitle;
        this.descriptionSubtitle = item.achievementDescription;
        this.descriptionModal = true;
      }
    },
    onShowIndexOFP() {
      this.indexOFPModal = true;
    },
    onResize() {
      this.setAchievements();
    },
    onHashChange() {
      if (this.$route.name !== 'Dashboard') {
        window.removeEventListener('hashchange', this.onHashChange);
        return;
      }
      const hash = window.location.hash.split('=');
      if (hash[0] === '#!showAchievements') this.showAchievements(hash);
      else if (hash[0] === '#!showOFP') this.showOFP(hash);
      else {
        this.achievementsModal = false;
        this.indexOFPModal = false;
      }
    },
    onSettings() {
      if (this.$props.hideEdit !== true) return;
      this.$router.push({ name: 'Settings' }).catch(() => {});
    },
    onEditAvatar() {
      this.showSetAvatar = true;
    },
    getPercent() {
      if (this.nextLevelValue > 0) {
        let percent = ((this.currentValue - this.currentLevelStartValue) / (this.nextLevelValue - this.currentLevelStartValue)) * 100 + 5;
        if (percent > 100) percent = 100;
        return percent;
      }
      return 5;
    },
    setAchievementsAll() {
      if (this.theme === '' || this.showAchievementTypes.length === 0) {
        this.achievementsAll = AchievementsAll;
        return;
      }
      this.achievementsAll = AchievementsAll.filter((i) => this.showAchievementTypes.includes(i.cat));
    },
    setAchievements() {
      this.activeAchievements = this.getAchievements();
      this.grayAchievements = this.getGrayAchievements();

      // Рассчитываем общее количество отображаемых достижений
      const totalDisplayed = this.activeAchievements.length + this.grayAchievements.length;

      // Показываем "+N" если есть еще достижения
      if (this.$props.achievements) {
        this.countMore = Math.max(0, this.$props.achievements.length - totalDisplayed);
      } else {
        this.countMore = 0;
      }
    },
    getAchievements() {
      if (this.$props.achievements) {
        // Сначала показываем активные (разблокированные) достижения
        const activeAchievements = this.$props.achievements.filter((item) => item.unlocked);
        // Затем добавляем заблокированные достижения
        const lockedAchievements = this.$props.achievements.filter((item) => !item.unlocked);
        // Объединяем и берем первые 6
        return [...activeAchievements, ...lockedAchievements].slice(0, 6);
      }
      return [];
    },
    getGrayAchievements() {
      // Больше не нужен, так как все достижения показываются в activeAchievements
      return [];
    },
    getAchievementsOfCat(cat) {
      if (!this.$props.achievements) return [];
      return this.$props.achievements.filter((item) => item.achievementCategory === cat);
    },
    getActiveOfCatCount(cat) {
      if (!this.$props.achievements) return 0;
      return this.$props.achievements.filter((item) => item.achievementCategory === cat && item.unlocked).length;
    },
    getCountOfCat(cat) {
      if (!this.$props.achievements) return 0;
      return this.$props.achievements.filter((item) => item.achievementCategory === cat).length;
    },
    getVisibleItems(items) {
      if (this.activeAchievements.length > 0) {
        let count = 0;
        if (!this.$root.isMobile) count = this.maxDesktopItems - this.activeAchievements.length;
        else count = this.maxMobileItems - this.activeAchievements.length;
        if (count > 0) return items.slice(0, count);
        return [];
      }
      if (!this.$root.isMobile) return items.slice(0, this.maxDesktopItems);
      return items.slice(0, this.maxMobileItems);
    },
    isAchievementActive(achievementKey) {
      if (this.$props.achievements) {
        const found = this.$props.achievements.find((i) => i.achievementKey === achievementKey);
        return found ? found.unlocked : false;
      }
      return false;
    },
    setCollapsed(id) {
      const index = this.categories.findIndex((i) => i.id === id);
      if (index < 0) return;
      this.categories[index].collapsed = !this.categories[index].collapsed;
    },
    getAchievementName(achievementKey) {
      // Для новой структуры данных используем achievementKey как имя
      // Можно добавить маппинг имен если нужно
      return achievementKey;
    },
    getAchievementIconUrl(achievementKey) {
      if (this.$props.achievements) {
        const found = this.$props.achievements.find((item) => item.achievementKey === achievementKey);
        if (found && found.achievementIconUrl) {
          return found.achievementIconUrl;
        }
      }
      return '';
    },
    setOFPvalues() {
      const values = [];
      if (this.sportIndexes) {
        const items = [];
        if (this.sportIndexes.history) {
          items.push(...this.sportIndexes.history);
        }
        items.push({
          index: this.sportIndexes.index,
          startDate: this.sportIndexes.startDate,
          finishDate: this.sportIndexes.finishDate,
        });
        for (let i = 0; i < items.length; i += 1) {
          const dates = formatDateRange({ start: items[i].startDate, finish: items[i].finishDate, showYear: true });
          values.push({
            value: items[i].index,
            dates,
          });
        }
      }
      this.ofpValues = values;
    },
    formatDateRange(payload) {
      return formatDateRange(payload);
    },
    showAchievements(hash) {
      if (hash[1] === 'true') this.onSelected('Welcome');
      else {
        this.achievementsModal = false;
        this.clearHash();
      }
    },
    showOFP(hash) {
      if (hash[1] === 'true') this.onShowIndexOFP();
      else {
        this.indexOFPModal = false;
        this.clearHash();
      }
    },
    clearHash() {
      setTimeout(() => { window.location.hash = ''; }, 100);
    },
  },
  mounted() {
    this.getCodeMp();
    this.currentPosition();
    this.setAchievementsAll();
    this.setOFPvalues();
    window.addEventListener('resize', this.onResize);
    this.onResize();
    window.addEventListener('hashchange', this.onHashChange);
    this.onHashChange();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('hashchange', this.onHashChange);
  },
};
</script>

<style lang="scss" scoped>
  @import "./ProfileExperience";
  @import '../ConnectionGuide/ConnectionGuide';
</style>
